/** @format */

import React, { Suspense, useMemo } from "react";
import { Card } from "../resources/types";
import "./Activity.scss";
import { useLocation } from "react-router-dom";
import { CardErrorBoundary } from "./CardErrorBoundary";
import { staticCardTypes } from "../contentEditor/utils";

type Props = {
  card: Card;
  id: string;
};

const Activity: React.FC<Props> = ({ card, id }) => {
  const { pathname } = useLocation();
  const activity = card.Object;
  const formattedType =
    activity.type.charAt(0).toUpperCase() + activity.type.slice(1);

  const Card = useMemo(() => {
    const _staticCardTypes = staticCardTypes.filter(
      (type) => !["gallery", "carousel"].includes(type.id),
    );

    if (process.env.PLATFORM === "SCORM") {
      return React.lazy(
        () => import(`./CardBase`), // UPDATE PATH
      );
    } else if (_staticCardTypes.find((_type) => activity.type === _type.id)) {
      return React.lazy(
        () => import(`./cards/StaticCard/StaticCard`), // UPDATE PATH
      );
    } else {
      return React.lazy(
        () => import(`./cards/${formattedType}Card/${formattedType}Card`), // UPDATE PATH
      );
    }
  }, [formattedType, activity.type]);

  return (
    <CardErrorBoundary
      type={formattedType}
      id={card.UUID}
      card={card}
      message={
        <small>
          {pathname}#{card.UUID}
        </small>
      }
    >
      <Suspense>
        <Card id={id} card={card} />
      </Suspense>
    </CardErrorBoundary>
  );
};

export default Activity;
